module.exports = __webpack_public_path__ + "static/media/1.be1a2161.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16055/1.jpg
// module id = 529
// module chunks = 0